<template>
  <v-window-item value="experience">
    <v-card-text>
      <v-card
        v-for="employment in userExperienceInfoData"
        :key="employment.id"
        variant="outlined"
        class="mb-4"
      >
        <v-card-title class="text-subtitle-1">
          <v-icon class="me-1" size="small">mdi-briefcase-outline</v-icon>
          {{ employment.company_name || 'N/A' }}
        </v-card-title>

        <v-card-text>
          <v-card variant="tonal" class="py-4">
            <v-row>
              <v-col cols="12" md="6">
                <v-list-item
                  prepend-icon="mdi-badge-account-outline"
                  title="Designation"
                  :subtitle="(employment.designation) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-briefcase-clock-outline"
                    title="Job Type"
                    :subtitle="(employment.job_type) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-calendar-start"
                    title="Date of Joining"
                    :subtitle="(formattedDate(employment.date_of_joining)) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-calendar-end"
                    title="Date of Relieving"
                    :subtitle="(formattedDate(employment.date_of_relieving)) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-currency-bdt"
                    title="Last Drawn Salary"
                    :subtitle="(employment.last_drawn_salary) || 'N/A'"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-list-item
                    prepend-icon="mdi-account-tie-outline"
                    title="Reporting To"
                    :subtitle="(employment.reporting_to) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-phone-outline"
                    title="Reporting Officer Contact"
                    :subtitle="(employment.reporting_officer_contact) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-map-marker-outline"
                    title="Company Address"
                    :subtitle="(employment.company_address) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-comment-text-outline"
                    title="Reason for Leaving"
                    :subtitle="(employment.reason_for_leaving) || 'N/A'"
                />

                <v-list-item
                  prepend-icon="mdi-check-circle-outline"
                  title="Status"
                  :subtitle="employment.status == null ? 'N/A' : employment.status == 1 ? 'Active' : 'Inactive'"
                />
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
      </v-card>

      <v-alert
        v-if="userExperienceInfoData.length === 0"
        type="info"
        variant="tonal"
      >
        No previous employment records found.
      </v-alert>
    </v-card-text>
  </v-window-item>
</template>

<script setup>
import formattedDate from "@/plugins/dateFormatter.js";

defineProps({
  userExperienceInfoData: {
    type: Array,
    default: () => []
  }
})
</script>
